import { FC, useCallback } from 'react'
import { Page } from '../../../components/Page'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { useLocation as useLocationData } from '../../../api/apiQueries'
import { NavTabs } from '../../../components/NavTabs'
import { useAuthorizedTabs } from '../../../hooks/useAuthorizedTabs'
import { UnauthorizedPage } from '../../UnauthorizedPage'

export const LocationManagementPage: FC = () => {
  const { sid: locationId } = useParams()
  const locationQuery = useLocationData(locationId)

  const navigate = useNavigate()

  const locationData = locationQuery.data

  const { tabs, isUnauthorized } = useAuthorizedTabs(
    [
      { label: 'Location Settings', to: 'settings', dataTestId: 'location-settings-tab' },
      { label: 'Practice Mode', to: 'practice-mode', dataTestId: 'practice-mode-tab' },
      { label: 'Permits', to: 'permits', dataTestId: 'permits-tab' },
      { label: 'Jurisdiction Details', to: 'jurisdiction-details', dataTestId: 'jurisdiction-details-tab' },
      { label: 'Change Log', to: 'change-log', dataTestId: 'change-log-tab' },
      { label: 'Location Feature Viewer', to: 'location-features', dataTestId: 'location-features-tab' }
    ],
    { redirectToFirstTab: true, ready: !!locationData }
  )

  const handleSearch = useCallback(
    (locationId: string) => {
      navigate(`/locations/${locationId}/location-management/settings`)
    },
    [navigate]
  )

  return (
    <Page title="Location Management" onSearch={handleSearch}>
      {locationData && (
        <>
          <NavTabs tabs={tabs} />
          {isUnauthorized ? <UnauthorizedPage /> : <Outlet />}
        </>
      )}
    </Page>
  )
}
